import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const DELAY_MS = 1700;

interface SceneBridgeStepProps {
  onComplete: () => void;
}

const SceneBridgeStep = ({ onComplete }: SceneBridgeStepProps) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(false), DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen min-w-full fixed inset-0 bg-background-dark">
      <AnimatePresence mode="wait">
        {isVisible && (
          <motion.div
            key="bridge"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
            onAnimationComplete={onComplete}
          >
            <div className="min-h-screen pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] bg-background-dark">
              <div
                className="rounded-full w-[1020px] h-[1020px] absolute top-[-699px] left-1/2 -translate-x-1/2 flex flex-col justify-end items-center"
                style={{
                  background:
                    'radial-gradient(50% 50% at 50% 50%, #0D0E12 23.08%, #0D0E12 73.08%, #130757 92.31%, #19009C 100%)'
                }}
              >
                <img src="/assets/scene/scene_logo.png" alt="scene logo" className="w-[100px]" />
                <p className="text-[20px] leading-[24px] font-semibold text-pure-white mt-[33px] text-center mb-[36px]">
                  당신만의 이야기에 등장할
                  <br />
                  주인공을 선정할게요
                </p>
              </div>
              <div className="flex items-center justify-center gap-[36px] pt-[380px]">
                <img
                  src="/assets/icons/profile_bubble.png"
                  alt="profile bubble"
                  className="w-[88px] h-[88px]"
                />
                <MaterialSymbolClose />
                <img
                  src="/assets/icons/profile_bubble.png"
                  alt="profile bubble"
                  className="w-[88px] h-[88px]"
                />
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SceneBridgeStep;

const MaterialSymbolClose = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
      fill="white"
    />
  </svg>
);
